const SearchResultsSkeleton = () => {
    return (
        <div className="flex flex-col">
            {[...Array(5)].map((_, i) => (
                <div key={i} className="flex items-center justify-between h-[72px] px-6 border-b border-shadowborder animate-pulse">
                    <div className="h-4 w-32 bg-gray-200 rounded" />
                    <div className="flex gap-3">
                        <div className="h-8 w-48 bg-gray-200 rounded-full" />
                        <div className="h-8 w-36 bg-gray-200 rounded-full" />
                        <div className="h-8 w-24 bg-gray-200 rounded-full" />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default SearchResultsSkeleton;
